// extracted by mini-css-extract-plugin
export default {"loader":"Preloader_loader__K6kQg","shimmerSweep":"Preloader_shimmerSweep__YrS+X"};